import React, {useContext, useEffect, useState} from "react";
import styles from "../../../styles/main.module.css";
import Header from "../../components/header/header";
import SidebarProvider from "../../components/sidebar/sidebar";
import Title from "../../../components/title/title";
import {PrimaryButton} from "../../../components/input/inputs";
import Loading from "../../../components/loading/loading";
import TableComponent from "../../../components/table/table";
import axiosInstance from "../../../AxiosInstance";
import CreateBankAccountModal from "./modals/create_modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar} from "@fortawesome/free-solid-svg-icons";
import MyContext from "../../../MyContext";

export default function BankAccount() {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [showCreate, setShowCreate] = useState(false);
    const [rows, setRows] = useState([]);
    const [canPrimary, setCanPrimary] = useState(true);
    const company_factoring_approved = localStorage.getItem("company_factoring_approved") === "true";
    const seller_uuid = localStorage.getItem("seller_uuid");

    const setPrimary = (id) => {
        if(!canPrimary) return;
        setCanPrimary(false);
        axiosInstance.post(`bank_account/${id}/set_primary/`, {
            seller_uuid: seller_uuid
        }).then((response) => {
            load();
        })
    }

    const cols = [
        {title: "Primary", internal: "id", code: (row, data) => {
            return (
                <FontAwesomeIcon role={canPrimary ? 'button' : ''} icon={faStar} color={row.primary ? '#FFEA00' : 'grey'} onClick={() => {
                    setPrimary(row.id);
                }}/>
            )
            }},
        {title: "Nro. de Cuenta", internal: 'number'},
        {title: "CCI", internal: 'cci'},
        {title: "Entidad Bancaria", internal: 'bank.name'},
        {title: "Moneda", internal: 'currency.name'},
        {title: "Estado", internal: 'klimb_reference_id', code: (row, data) => data ? "Activo" : "Pendiente"}
    ];

    const load = () => {
        if(seller_uuid.length > 0) {
            axiosInstance.get(`bank_account/?seller_uuid=${seller_uuid}`).then((response) => {
                setRows(response.data);
                setCanPrimary(true);
            });
        }
    }

    useEffect(() => {
        load();
    }, [])

    return (
        <div className={styles.mainContainer}>
            <Header setSidebarOpen={setSidebarOpen}/>
            <SidebarProvider isOpen={sidebarOpen} index={8}/>

            <CreateBankAccountModal show={showCreate} setter={setShowCreate} reload={load} seller_uuid={seller_uuid}/>

            <div className={styles.container} style={!sidebarOpen ? {marginLeft: '80px'} : {marginLeft: '285px'}}>
                <Title name={'Mantenimiento de Cuentas Bancarias'}/>

                <div className={`${styles.secondaryContainer}`}>
                    {company_factoring_approved ?
                        <React.Fragment>
                            <div className={'d-flex justify-content-end'}>
                                <PrimaryButton name={'Agregar cuenta'} onClick={() => {
                                    setShowCreate(true);
                                }}/>
                            </div>
                            {
                                //Pagination HERE
                                rows?.length === 0 ? <Loading/> :
                                    <TableComponent
                                        fetchUrl={'bank_account'}
                                        noPagination={true}
                                        defaultFilters={{seller_uuid: seller_uuid}}
                                        pull={setRows}
                                        cols={cols}
                                        rows={rows}
                                    />
                            }
                        </React.Fragment>
                        :
                        <div className={'d-flex justify-content-center'}>Por favor complete todos los datos en la sección de empresa para habilitar factoring</div>
                    }
                </div>
            </div>
        </div>
    )
}